//app\javascript\shared\constants\locales.js

const locales = {
  en: 'English',
  es: 'Spanish',
};
export default locales;